var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingPageIconProfileImageEmpty04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#e5fae1;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 25,
    x2: 50,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ca62f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#7ea833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#86ae40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#92b854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a3c671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b9d896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bad998"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.68,7.32A25,25,0,0,0,7.32,42.68,25,25,0,0,0,42.68,7.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.3,41.9q-.23.42-.42.84a28.54,28.54,0,0,0-1.33,3.38c-.1.32-.21.65-.32,1a23.17,23.17,0,0,0,11.54,0c-.11-.33-.22-.66-.32-1a28.54,28.54,0,0,0-1.33-3.38q-.2-.42-.42-.84a16.9,16.9,0,0,1-7.4,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,8.66A16.83,16.83,0,1,0,41.83,25.49,16.85,16.85,0,0,0,25,8.66ZM36.2,28.33a10.83,10.83,0,0,1-21.3,0,.48.48,0,0,1,.69-.52,22.8,22.8,0,0,0,19.92,0A.48.48,0,0,1,36.2,28.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPageIconProfileImageEmpty04);
export default __webpack_public_path__ + "static/media/setting_page_icon_profile_image_empty_04.bc3f414638c65cff4b79cea4a6e0e036.svg";
export { ForwardRef as ReactComponent };